import { Container, Box } from "@mui/material"
import Link from "./Link"

let navigation = [
  { 
    text: "works", 
    link: "/"
  },
  /*
  {
    text: "gallery",
    link: "/gallery"
  },
  */
  {
    text: "links",
    link: "/links"
  },
  {
    text: "generators",
    link: "/generators"
  },
  {
    text: "prints",
    link: "mailto:prints@pxlq.art"
  },
  {
    text: "mail",
    link: "mailto:hi@pxlq.art"
  }
]

const Header = ({ context }) => {
  return (
    <Container maxWidth={false} disableGutters>
      <Box display="flex" mt={2} mr={{xs: 0, sm: 2}} justifyContent={{xs: "center", sm: "right"}}>
        {navigation.map((item, i) => (
          <Box key={i} display={"flex"}>
            <Link 
              label = {item.text} 
              url = {item.link}
              size = {{xs: "0.8rem", sm: "1.0rem"}}
              padding = {{xs: 0.7, sm: 1.0}}
              style = {{
                "color": "black",
                "textDecoration": "none",
                "textTransform": "capitalize",
                "fontStyle": context === item.text ? "italic" : "normal",
              }}
              hover = {{
                "color": "black",
                "backgroundColor": "#c1b9ab93",
                "cursor": "crosshair",
                "textDecoration": "none"
              }}
            />
          </Box>
        ))}
      </Box>
    </Container>
  )
}

export default Header